import React from "react";
import { QrCode, Gift, Trophy, Ticket, Heart, Recycle } from "lucide-react";

const ACTIVATIONS = [
  {
    tag: "QR Activation",
    title: "Scan-to-Win Bottles",
    body: "Each label hides a unique QR code. Scans unlock contests, menus, loyalty points — and feed straight into your analytics dashboard.",
    icon: QrCode,
    stat: "+38% scan-to-lead conversion",
    accent: "#0A2A6B",
  },
  {
    tag: "Loyalty Drop",
    title: "VIP Member Bottles",
    body: "Tier-exclusive labels for your top clients. Premium drop, premium feeling — without premium overhead.",
    icon: Gift,
    stat: "27% repeat-visit lift",
    accent: "#1D4ED8",
  },
  {
    tag: "Event Pass",
    title: "Bottle = Entry Token",
    body: "Branded bottles handed at check-in. Doubles as a wayfinder, sponsor billboard and lasting souvenir.",
    icon: Ticket,
    stat: "10,000+ touchpoints / event",
    accent: "#0A0A0A",
  },
  {
    tag: "Real Estate Closing",
    title: "The Welcome Home Bottle",
    body: "Custom bottles waiting on the kitchen counter the day they move in. Goes everywhere the conversation goes.",
    icon: Heart,
    stat: "94% referral recall",
    accent: "#7F1D1D",
  },
  {
    tag: "Cause Campaign",
    title: "1 Bottle = 1 Donation",
    body: "Every scan triggers a charitable contribution. Aligns your brand with purpose — and proves it with data.",
    icon: Trophy,
    stat: "Avg 2x social shares",
    accent: "#064E3B",
  },
  {
    tag: "Sustainability",
    title: "Refill Programs",
    body: "Branded glass and aluminum options for restaurants, hotels and offices. Premium materials, recyclable shells.",
    icon: Recycle,
    stat: "100% recyclable",
    accent: "#0F766E",
  },
];

export const Activations = () => {
  return (
    <section
      data-testid="activations-section"
      className="py-24 sm:py-32 bg-white border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-10 items-end mb-16">
          <div>
            <div className="overline mb-4">Campaign Ideas</div>
            <h2 className="font-display text-4xl sm:text-6xl font-black tracking-tighter leading-[0.92]">
              Bottles do
              <br />
              <span className="font-editorial italic font-medium">
                more than hydrate.
              </span>
            </h2>
          </div>
          <p className="text-slate-600 text-lg md:text-right">
            Steal these from our playbook. Then come build something better with
            us.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ACTIVATIONS.map((a, i) => {
            const Icon = a.icon;
            return (
              <div
                key={a.title}
                data-testid={`activation-${i}`}
                className="group relative rounded-2xl border border-slate-200 bg-white p-8 card-lift overflow-hidden"
              >
                <div
                  className="absolute -top-12 -right-12 w-40 h-40 rounded-full opacity-10 group-hover:opacity-20 transition-opacity"
                  style={{ background: a.accent }}
                />
                <div className="relative">
                  <div className="flex items-center justify-between mb-6">
                    <div
                      className="w-12 h-12 rounded-2xl flex items-center justify-center text-white"
                      style={{ background: a.accent }}
                    >
                      <Icon size={20} />
                    </div>
                    <span className="font-mono text-[10px] uppercase tracking-widest text-slate-400 bg-slate-100 px-2 py-1 rounded-full">
                      {a.tag}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl font-bold tracking-tight mb-3">
                    {a.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed mb-6">
                    {a.body}
                  </p>
                  <div className="pt-4 border-t border-slate-100 font-mono text-xs uppercase tracking-widest text-slate-700">
                    → {a.stat}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
